
import { defineComponent, PropType } from "vue";
import ComparisonsCarousel from "@components/start/comparisons-carousel.vue";
import PortfoliosCarousel from "@components/start/portfolios-carousel.vue";
import WatchlistCarousel from "@components/start/watchlist-carousel.vue";

export default defineComponent({
  name: "ProductsTabs",
  components: { ComparisonsCarousel, PortfoliosCarousel, WatchlistCarousel },
  props: {
    comparisonsLoading: { type: Boolean, default: true },
    comparisons: { type: Array as PropType<Comparisons.Details.Instance[]>, default: () => [] },
    comparisonsCount: { type: Number, default: 0 },
    portfoliosLoading: { type: Boolean, default: true },
    portfolios: { type: Array as PropType<Portfolios.TileData[]>, default: () => [] },
    portfoliosCount: { type: Number, default: 0 },
    watchlistLoading: { type: Boolean, default: true },
    watchlistProducts: { type: Array as PropType<Products.Followed.TileData[]>, default: () => [] },
    watchlistProductsCount: { type: Number, default: 0 },
  },
  emits: ["tracking-click"],
  methods: {
    propagateTrackClick(options: InternalTracking.TrackClickOptions) {
      this.$emit("tracking-click", options);
    },
  },
});
